module.exports = __webpack_public_path__ + "static/media/0s.ea05791f.png";